import { Config } from '../../../config'
import styled, { keyframes } from 'styled-components'

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const Spinner = styled.div`
  animation: ${rotate360} 1s linear infinite;
  transform: translateZ(0);
  border-top: 0.2rem solid ${({ theme }) => theme.palette.lightgrey};
  border-right: 0.2rem solid ${({ theme }) => theme.palette.lightgrey};
  border-bottom: 0.2rem solid ${({ theme }) => theme.palette.lightgrey};
  border-left: 0.4rem solid ${({ theme }) => theme.palette.silverTree};
  background: transparent;
  width: 4.4rem;
  height: 4.4rem;
  border-radius: 50%;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`
